import type {
    DmApis,
    Extension,
    ExtensionAPI,
    ValidatorMap,
    ValidatorResult,
    CreateExtensionArgument
} from '@wix/document-manager-core'
import {ReportableError} from '@wix/document-manager-utils'
import type {Pointer} from '@wix/document-services-types'
import type {SchemaExtensionAPI} from './schema/schema'

export interface BackgroundMediaExtensionAPI extends ExtensionAPI {
    backgroundMedia: {}
}

const createValidator = (apis: DmApis): ValidatorMap => {
    const {coreConfig, extensionAPI} = apis
    const {schemaAPI} = extensionAPI as SchemaExtensionAPI
    const isStrictValidationEnabled = coreConfig.experimentInstance.isOpen('dm_strictBackgroundMediaValidation')

    if (isStrictValidationEnabled) {
        return {
            validateBackgroundMediaStrict: (pointer: Pointer, value: any): ValidatorResult[] => {
                if (value?.type !== 'BackgroundMedia') {
                    return []
                }

                try {
                    schemaAPI.validate('BackgroundMedia', value, pointer.type)
                    return []
                } catch (error: any) {
                    coreConfig.logger.captureError(
                        new ReportableError({
                            message: `Strict validation failed for BackgroundMedia`,
                            errorType: 'strictBackgroundMediaValidation',
                            extras: {
                                itemId: value.id,
                                itemType: value.type,
                                namespace: pointer.type,
                                validationError: error.message,
                                problematicValue: value
                            }
                        })
                    )

                    return [
                        {
                            shouldFail: true,
                            type: 'strictBackgroundMediaValidation',
                            message: `Strict validation failed for BackgroundMedia: ${error.message}`
                        }
                    ]
                }
            }
        }
    }

    return {}
}

const createExtension = ({}: CreateExtensionArgument): Extension => ({
    name: 'backgroundMedia',
    createValidator
})

export {createExtension}
